module.exports = __webpack_public_path__ + "static/media/Abelle.561283d1.jpeg";